import z from 'zod';
import { optionSchema } from '~/features/types';
import { nonNegativeInt, positiveNumber } from '~/features/utils';

export const ShiftDetailsFormSchema = z.object({
  id: z.number().optional(),
  jobListingId: z.number().optional(),
  // Shift Allocation
  numDayShifts: nonNegativeInt,
  numEveShifts: nonNegativeInt,
  numNightShifts: nonNegativeInt,
  numOfWeDayShifts: nonNegativeInt,
  numOfWeEveShifts: nonNegativeInt,
  numOfWeNightShifts: nonNegativeInt,
  numHolDayShifts: nonNegativeInt,
  numHolEveShifts: nonNegativeInt,
  numHolNightShifts: nonNegativeInt,
  // Shift Differentials
  shiftDiffType: optionSchema,
  eveShiftRateDiff: positiveNumber,
  nightShiftRateDiff: positiveNumber,
  weDayShiftRateDiff: positiveNumber,
  weEveShiftRateDiff: positiveNumber,
  weNightShiftRateDiff: positiveNumber,
  holDayShiftRateDiff: positiveNumber,
  holEveShiftRateDiff: positiveNumber,
  holNightShiftRateDiff: positiveNumber,
});

export type ShiftDetailsFormValues = z.infer<typeof ShiftDetailsFormSchema>;
